import React 					from 'react';
import ReactDOM 				from 'react-dom';

import BLComponent				from '../core/_BLComponent.jsx';
import {CustomAlert,NotificationBar} 			
								from '../common/_Utilities.jsx';
import ModalFrame 				from '../common/_ModalFrame.jsx';
import {ClickShowTooltip}		from '../common/_Utilities.jsx';

import SelectSourceOptions		from './selectSourceOptions.jsx';

export default class InventoryComparisonLanding extends BLComponent 
{
	

	render() {
		const {nothingToShow} = this.props.data.landingPageData; 
		const {invA, invB, invASourceFrom, invBSourceFrom} = this.props.data;
		
		return (
			<React.Fragment>
				{this.renderTitleBanner()}
				{this.renderNoticeBar()}
				<div className="inventory-comparison__inv-section-margin-top">
					<div className="l-center inventory-comparison__content-section">
						<div className="inventory-comparison__grid-split">
							<div className="inventory-comparison__grid-cell inventory-comparison__inv-section inventory-comparison__grid-inv-col">
								<div className="text--small-title text--bold inventory-comparison__inv-title">Inventory A</div>
								<div className="inventory-comparison__disp-flex-small-screen">
									<div className="l-center-v inventory-comparison__form-set inventory-comparison__margin-right-small-screen l-margin-top--sm">
										<div className="inventory-comparison__inv-info-title l-margin-right">Set ID</div>
										<div className="inventory-comparison__inv-inp">
											<input type="text" className="text-input l-full-width" value={this.props.data.invAItemNo} onKeyUp={(e) => this.checkEnterSubmit(e)} onChange={(e) => this.props.func.changeInvA( e.target.value )}/>
										</div>
									</div>
									{ invA.isError && this.renderInvalidSetId(false) }
									<div className="l-center-v inventory-comparison__form-set l-margin-top--sm">
										<div className="inventory-comparison__inv-info-title l-margin-right l-vertical-align-middle">Source</div>
										<div className="inventory-comparison__inv-inp">
											<select className="select l-full-width" onKeyUp={(e) => this.checkEnterSubmit(e)} onChange={(e) => this.props.func.changeInvASourceFrom( e.target.value )} value={this.props.data.invASourceFrom} >
												<option value="0">BrickLink data</option>
                                                <option value="1">LEGO Data</option>
											</select>
										</div>
									</div>
								</div>
								{ invA.isError && this.renderInvalidSetId(true) }
							</div>

							
							
							<div className="inventory-comparison__grid-cell inventory-comparison__grid-cell-hide-small-screen">
							    <div className="inventory-comparison__vertical-line">&nbsp;</div>
							</div>
							
							<div className="inventory-comparison__grid-cell inventory-comparison__inv-section inventory-comparison__grid-inv-col">
								<div className="text--small-title text--bold inventory-comparison__inv-title">Inventory B</div>
								<div className="inventory-comparison__disp-flex-small-screen">
									<div className="l-center-v inventory-comparison__form-set inventory-comparison__margin-right-small-screen l-margin-top--sm">
										<div className="inventory-comparison__inv-info-title l-margin-right">Set ID</div>
										<div className="inventory-comparison__inv-inp">
											<input type="text" className="text-input l-full-width" value={this.props.data.invBItemNo} onKeyUp={(e) => this.checkEnterSubmit(e)} onChange={(e) => this.props.func.changeInvB( e.target.value )}/>
										</div>
									</div>
									{ invB.isError && this.renderInvalidSetId(false) }
									<div className="l-center-v inventory-comparison__form-set l-margin-top--sm">
										<div className="inventory-comparison__inv-info-title l-margin-right">Source</div>
										<div className="inventory-comparison__inv-inp">
											<select className="select l-full-width" onKeyUp={(e) => this.checkEnterSubmit(e)} onChange={(e) => this.props.func.changeInvBSourceFrom( e.target.value )} value={this.props.data.invBSourceFrom}>
												<option value="0">BrickLink data</option>
                                                <option value="1">LEGO data</option>
											</select>
										</div>
									</div>
								</div>
								{  invB.isError && this.renderInvalidSetId(true) }
							</div>
							
							<div className="inventory-comparison__grid-cell inventory-comparison__grid-cell-span--all inventory-comparison__inv-section text--center">
								<button className="btn btn--cta l-margin-top--l" onClick={()=>this.props.func.submitForm()}>Compare</button>
								{ nothingToShow ? this.renderNothingToShow():""}
							</div>
						</div>
					
					</div>
				</div>
			</React.Fragment>
		);
	}

	renderInvalidSetId( isMobile ) {
		if (!isMobile)
			return(
				<div className="inventory-comparison__error-msg inventory-comparison__error-msg-color inventory-comparison__grid-cell-hide-small-screen l-margin-top--sm">
					<div className="l-full-width text--right">Invalid Set ID. Please try again.</div>
				</div>
			)
		else
			return(
				<div className="inventory-comparison__error-msg inventory-comparison__error-msg-color inventory-comparison__grid-cell-show-small-screen l-margin-top--sm">
					<div className="l-full-width text--left">Invalid Set ID. Please try again.</div>
				</div>
			)
	}

	renderNothingToShow() 
	{
		return(
			<div className="inventory-comparison__nothing-to-show-section">
				<i className="fas fa-clipboard-list inventory-comparison__nothing-to-show-icon"></i>
				<div className="inventory-comparison__nothing-to-show-context">
				<div className="inventory-comparison__text-color--darkest16 text--title">Nothing to show</div>
				<div className="inventory-comparison__text-color--darkest16 l-margin-bottom--xxxl">Please select two set inventories above to compare.</div>
				</div>
			</div>
		)
	}

	renderTitleBanner()
	{
		return (
			<div className="inventory-comparison__title-banner-section">
				<div className="l-center">
					<div className="inventory-comparison__grid-split">
						<div className="inventory-comparison__grid-cell inventory-comparison__grid-cell-span--all  inventory-comparison__title-banner">
							<div className="text--left inventory-comparison__title-container l-vertical-align-middle inventory-comparison__title-container">
								<div className="text--uppercase inventory-comparison__text-color--overlayColorMediumTrans">inventory comparison</div> 
								<div className="inventory-comparison__title">Compare two set inventories to see key differences</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	renderNoticeBar()
	{
		return (
			<div className="inventory-comparison__title-banner-section inventory-comparison__notice-bar">
				<div className="l-center">
					<div className="inventory-comparison__grid-split">
						<div className="inventory-comparison__grid-cell inventory-comparison__grid-cell-span--all inventory-comparison__padding--sm text--center">
							<i className="fas fa-exclamation-circle inventory-comparison__text-color--darkest48"></i> <span className="inventory-comparison__text-color--darkest">We do not currently have complete data for LEGO inventories older than 1995.</span>
						</div>
					</div>
				</div>
			</div>
		)
	}

	checkEnterSubmit(e)
	{
		if (e.keyCode == 13) {
        	this.props.func.submitForm();
    	}
	}

}